export default "__VITE_ASSET__DrIj9GBO__"